import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Stack} from '@vio/atlas/helpers/Stack'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/src/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

import {FacetFilterProps, RenderType} from '.'

const SkeletonRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  gap: ${cssTheme.layout.spacing.s300};

  & > div {
    flex: 1;
  }

  ${linariaMq.desktopXs} {
    min-width: 400px;
  }
`

type Props = Pick<FacetFilterProps, 'renderType'>

export const FacetFilterContentLoader: React.FC<Props> = ({renderType}) => {
  const blocks = renderType === RenderType.Card ? 1 : 2
  return (
    <Box paddingBottom="s600">
      <Stack space="s600">
        {Array.from({length: blocks}).map((_, index) => (
          <Stack key={index} space="s400">
            <SkeletonRow>
              <SkeletonLoader />
              <SkeletonLoader marginTop={0} />
            </SkeletonRow>
            <SkeletonRow>
              <SkeletonLoader />
              <SkeletonLoader marginTop={0} />
            </SkeletonRow>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}
